import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import Create from './Create'
import List from './List'
import Edit from './Edit'

const Cities = ({ match }) => (
  <div>
    <Route
      exact
      path={match.url}
      render={props => <List {...props} />}
    />
    <Switch>
      <Route exact path={`${match.url}/add`} component={Create} />
      <Route
        path={`${match.url}/:id`}
        render={props => <Edit {...props} />}
      />
    </Switch>
  </div>
)

Cities.propTypes = {
  match: PropTypes.object.isRequired
}

export default Cities
